import dynamic from 'next/dynamic';

const liveBlogList = {
  VariantComponent: dynamic(
    () => import(/* webpackChunkName: "blazePbliveBlogList" */ './LiveBlogList')
  ),
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'liveBlogList'
  })
};

export default liveBlogList;
